export const AreaSearchKind = {
  KODATE: 1,
  MANSION: 2,
  LAND: 3,
};

export const AreaSearchType = {
  SHINCHIKU: 1,
  CHUKO: 2,
  ALL: 3,
};
